import Clarity from '@microsoft/clarity';
import { Config } from '@/utils/config';

let isInitialized = false;

export function initClarity() {
  const clarityId = Config.CLARITY_ID;
  if (!clarityId || isInitialized) return;
  try {
    Clarity.init(clarityId);
    isInitialized = true;
  } catch (err) {
    console.error('Failed to initialize Microsoft Clarity:', err);
  }
}

// userId is the Proposal.biz user id, sent as Clarity's custom-id and hashed on the client
// before it reaches Clarity. It matches the id used for PostHog and Sentry, so a user's builder
// sessions line up with their dashboard sessions. friendlyName is shown verbatim in the Clarity
// dashboard, so never pass an email or other sensitive value. userId/email/workspaceId/
// workspaceName are also set as custom tags (unhashed) so sessions can be matched against the
// admin panel's User ID, User Email ID, Workspace ID, and Workspace Name columns. The user id tag
// is named "appUserId", not "userId" — Clarity treats "userId" as reserved for identify()'s own
// custom-id and silently drops a tag with that exact key instead of showing it under Custom tags.
export function identifyClarity(
  userId: number | string,
  friendlyName?: string | null,
  pathname?: string,
  email?: string | null,
  workspaceId?: number | string | null,
  workspaceName?: string | null,
) {
  if (!Config.CLARITY_ID) return;

  if (!isInitialized) initClarity();

  try {
    Clarity.identify(
      String(userId),
      undefined,
      pathname ?? window.location.pathname,
      friendlyName ?? undefined,
    );
    Clarity.setTag('appUserId', String(userId));
    if (email) Clarity.setTag('userEmail', email);
    if (workspaceId != null) Clarity.setTag('workspaceId', String(workspaceId));
    if (workspaceName) Clarity.setTag('workspaceName', workspaceName);
  } catch (err) {
    console.error('Failed to call Clarity identify:', err);
  }
}
